import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _TaxSchemeContextCode } from '../../../../../core/services/dataBean/EntityCatalog';


interface Props {
    schema: number;
    idSelector: number;
    onChange: any;
    label?: string;
}

export const TaxSchemeContextCodeEditor = ({ schema, idSelector, onChange, label }: Props) => {

    const taxScheme = useDataBean(_TaxSchemeContextCode)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
        getLista();
    }, [schema])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        taxScheme.instance.getTaxSchemeContextCodeCatalog(schema).then(
            (resp) => {
                setLista(resp)
                // if (resp.length > 0 && !idSelector) {
                //     setID(resp[0].DataBeanProperties.IDAppointment)
                // }
            }
        )
    }

    return (
        <>
            <label>{label ?? "Actividades de los Esquemas de Impuestos"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDTaxSchemeContextCode} >{item.DataBeanProperties.Code} - {item.DataBeanProperties.Description}</option>
                        )
                    })
                }
            </select>
        </>
    )
}